import { strIsNullOrEmpty, tryParseJSONObject } from '@fox/atoms/utils/string';
import { QuestionBlockMetadata } from '../../question-block/contracts';
import { DataTableRowAnswer } from '../../question-block/question-renders/data-table/helpers';
import { QuestionValidator } from '../util/allow-next';

export const dataTableRequirementsValidator: QuestionValidator = (answer, metadataJson) => {
	if (!answer) return false;
	const parsedAnswer = tryParseJSONObject<DataTableRowAnswer[]>(answer?.answer?.answerJson, []);
	const fieldMeta = tryParseJSONObject<QuestionBlockMetadata>(metadataJson, {});

	if (fieldMeta?.dataTableType === 'customField') {
		const customFields = fieldMeta?.dataTableCustomFields ?? [];
		const requiredAnswers = customFields.filter(c => c.required);
		return parsedAnswer.every(a => {
			return requiredAnswers.every(c => {
				const value = a?.[c.fieldId];
				if (c.type === 'checkbox') {
					return value === '1';
				} else if (c.type === 'select') {
					const vals = tryParseJSONObject<string[]>(value, []);
					return vals.length > 0;
				} else {
					return !strIsNullOrEmpty(value);
				}
			});
		});
	} else {
		const columns = fieldMeta?.columns ?? [];
		const requiredCols = columns.filter(c => c.required);
		return parsedAnswer.every(a => {
			return requiredCols.every(c => {
				return !strIsNullOrEmpty(a?.[c.id]);
			});
		});
	}
};
